import React from 'react';
import { API_URL } from './pdfConstants';

const ThumbnailImage = React.memo(({ documentId, pageNum, alt }) => {
  const [blobUrl, setBlobUrl] = React.useState(null);
  const [failed, setFailed] = React.useState(false);
  const containerRef = React.useRef(null);
  const loadedRef = React.useRef(false);

  React.useEffect(() => {
    if (loadedRef.current) return;
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loadedRef.current) {
          loadedRef.current = true;
          observer.disconnect();
          const token = localStorage.getItem('token');
          const url = `${API_URL}/api/documentos/manuales/${documentId}/visor/pagina/${pageNum}?quality=low`;
          fetch(url, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(r => {
              if (!r.ok) throw new Error(r.status);
              return r.blob();
            })
            .then(blob => setBlobUrl(URL.createObjectURL(blob)))
            .catch(() => setFailed(true));
        }
      },
      { rootMargin: '300px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [documentId, pageNum]);

  // Limpiar blob URL al desmontar
  React.useEffect(() => {
    return () => { if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [blobUrl]);

  if (blobUrl) {
    return <img src={blobUrl} alt={alt} className="w-full h-auto" draggable={false} />;
  }
  return (
    <div ref={containerRef} className="w-full aspect-[3/4] bg-slate-700 flex items-center justify-center">
      {failed 
        ? <span className="text-slate-500 text-xs">--</span>
        : <div className="w-4 h-4 border-2 border-slate-500 border-t-teal-400 rounded-full animate-spin" />
      }
    </div>
  );
});

ThumbnailImage.displayName = 'ThumbnailImage';

export default ThumbnailImage;
